/**
 * @ngdoc component
 * @name home.component:homeManager
 *
 * @description
 

*/
(function () {
    'use strict';

    var homeManagerCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'home-event-manager.html',
        controller: homeManagerCtrl
    };

    angular.module('itxApp.common').component('homeEventManager', homeManagerCmp);

    homeManagerCmp.$inject = [
        'ngDialog',
        'homeEventManagerSvc',
        'ItxConfigurationSvc',
        'ItxUtilsFct',
        'BannersService',
        'NavigationService',
        'CountryService',
        'ItxTranslateSvc',
        'CmsConfigSvc',
        'DUTTI_CONS',
        'CommonServices'
    ];

    function homeManagerCtrl(
        ngDialog,
        homeEventManagerSvc,
        ItxConfigurationSvc,
        ItxUtilsFct,
        BannersService,
        NavigationService,
        CountryService,
        ItxTranslateSvc,
        CmsConfigSvc,
        DUTTI_CONS,
        CommonServices
    ) {
        var _this = this;
        _this.loadedTranslations = false;
        _this.initializedEvents = false;
        _this.notAllowdPagesForModals = ['ItxMassimoDuttiFeelPage'];

        _this.$onInit = function () {
            // fix temporal transición login.
            if (ItxUtilsFct.isRtlLanguage()) {
                $('body').addClass('login-rtl');
            }

            homeEventManagerSvc.loadCommonTranslationsAsync(inditex.iLangId).then( () => {
                _this.loadedTranslations = true;
            });

            if (CountryService.isWWCountryId(Inditex.iStoreId)) {
                var countryIso = inditex.getLocalStorage('COUNTRY_ISO');
                if (!countryIso && Object.keys(inditex.iWWCountryCodes).indexOf(inditex.iStoreJSON.countryCode) < 0) {
                    NavigationService.goToWorldWidePage();
                }
            }

            var lastStore = homeEventManagerSvc.getLastStore();
            //Si tenemos los parametros necesarios --> StoreId, Lang, y Section(segun la activación)
            if (lastStore && lastStore.storeId && !lastStore.section) {
                lastStore.section = 'WOMEN';
            }
            if (
                lastStore &&
                homeEventManagerSvc.validHomeParams(
                    lastStore.storeId,
                    lastStore.langId,
                    lastStore.section
                )
            ) {
                _this.tmpLastStore = {
                    store: { id: inditex.iStoreId },
                    lang: { id: inditex.iLangId },
                    section: lastStore.section
                };

                //Mostramos home..
                _this.homeStatus = 'HOME';
            }
            //SI no tiene valid params pero,No tenemos lastStore inicializado (entras por primera vez)
            else if (lastStore === null) {
                //Carga pais directamente por primera vez
                _this.tmpLastStore = {
                    store: { id: inditex.iStoreId },
                    lang: { id: inditex.iLangId },
                    section: localStorage.LAST_SECTION
                };

                //Mostramos home..
                _this.homeStatus = 'HOME';
            } else {
                history.replaceState({}, null, '/');
                _this.homeStatus = 'WORLDWIDE_PENDING_INFO';
            }

            inditex.onReady(function () {
                ItxTranslateSvc.waitTranslations().then(function () {
                    _this.initEvents();
                });
            });
            _this.checkOrderStatus();
        };

        _this.saveGeoblockingConfiguration = function (saveStore) {
            homeEventManagerSvc.saveLastStore(
                _this.tmpLastStore.store.id,
                _this.tmpLastStore.lang.id,
                _this.tmpLastStore.section,
                saveStore
            );
        };

        _this.handleBannerClose = function (bannerType, action) {
            if (bannerType === BannersService.banners.ask.value && action.saveStore != undefined) {
                _this.saveGeoblockingConfiguration(action.saveStore);
            }
        };

        _this.saveDefaultStore = function () {
            homeEventManagerSvc.saveLastStore(
                _this.tmpLastStore.store.id,
                _this.tmpLastStore.lang.id,
                _this.tmpLastStore.section
            );
        };

        _this.checkLastStoreDialogs = function () {
            var lastStoreJson = homeEventManagerSvc.getLastStore();
            var isCurrentStoreSaved = lastStoreJson && _this.tmpLastStore && _this.tmpLastStore.store.id === lastStoreJson.storeId;
            var isNotSameStoreId = lastStoreJson && lastStoreJson.storeId != inditex.storeId;

            CmsConfigSvc.getProperty('geoblocking_enabled')
                .then(function(data) {
                    _this.enableBannersByGeoblocking( data, isCurrentStoreSaved, isNotSameStoreId );
                }).catch(function() {
                    _this.enableBannersByGeoblocking( false, isCurrentStoreSaved, isNotSameStoreId );
                })
        };

        _this.enableBannersByGeoblocking = function(data, isCurrentStoreSaved, isNotSameStoreId) {
          
            _this.isgeoBlockingEnabled = data;
            // Se comprueba si se ha guardado Store por defecto o si este no es el mismo al que estamos accediendo
            if (!isCurrentStoreSaved || isNotSameStoreId) {
                // Si no esta guardada y el geoblocking esta activado muestra el modal
                if (_this.isgeoBlockingEnabled) {
                    BannersService.openBanner(BannersService.banners.ask.value, true);
                    BannersService.verifyBuyCookie();
                    // _this.showAskDefaultStoreDialog = true;
                }
                // Si no esta activado el geoblocking la guarda como tienda por defecto
                else {
                    // _this.showRedirectPopup = true;
                    BannersService.openBanner(BannersService.banners.redirect.value, true);
                    BannersService.verifyBuyCookie();
                    _this.saveDefaultStore();
                }
            }
        };

        _this.initEvents = function () {
            if (!_this.initializedEvents) {
                _this.initializedEvents = true;

                // MDECOMM-15687 - Activación Stores sistemas.
                // if(inditex.iStoreListJSON && inditex.iStoreListJSON.stores){
                //     //HACK QUE actualiza el continente
                //     CountryService.updateCountryContinent(inditex.iStoreListJSON.stores);
                // }

                _this.checkLastStoreDialogs();
                //ManagerSvc.imTriggerHomePageview();
                if (
                    inditex.iUrlJSON.params['hash'] &&
                    _this.notAllowdPagesForModals.indexOf(inditex.iPage) === -1
                ) {
                    CmsConfigSvc.getProperty('enable_login_apolo')
                    .then(function (newLoginEnable) {
                        if (!newLoginEnable) {
                            ngDialog.open({
                                template: 'user-access-dialog-wrapper.tpl',
                                className:
                                    'new-modal ma-modal-sm recover-password-modal ngdialog-theme-plain',
                                showClose: true,
                                data: 'change-password'
                            });
                        } else {
                            const options = {
                                bubbles: true,
                                composed: true,
                                detail: {
                                    extra: {
                                        typeEvent: 'change-password',
                                        hash: inditex.iUrlJSON.params['hash']
                                    }
                                }
                            };
                            document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
                        }
                    });
                }

                if (inditex.iUrlJSON.params['massimo-dutti-feel']) {
                    ngDialog.open({
                        template: 'user-access-dialog-wrapper.tpl',
                        className:
                            'new-modal ma-modal-sm recover-password-modal ngdialog-theme-plain',
                        showClose: true,
                        data: 'recover-password'
                    });
                }

                //---ACCIONES CUSTOM----

                //CONFIRMACION NEWSLETTER
                if (inditex.iUrlJSON.params['newsletterConfirm']) {
                    homeEventManagerSvc.askNewsletterConfirm();
                }
                //CONFIRMACION CsBs
                if (inditex.iUrlJSON.params['showCSBSConfirm']) {
                    homeEventManagerSvc.askCsbsConfirm();
                }

                // Mensaje de cuenta eliminada con
                if (
                    inditex.iUrlJSON.params['showNewsletterConfirm'] === 'true' &&
                    inditex.iUrlJSON.params['unsubscription'] === 'true'
                ) {
                    homeEventManagerSvc.showNewsletterUnsubscriptionConfirmation();
                }

                //SESSION EXPIRED
                if (homeEventManagerSvc.isSessionExpired()) {
                    _this.homeStatus = 'HOME';
                    homeEventManagerSvc.showSessionExpiredMessage();
                    //homeEventManagerSvc.setHomeVariables();
                    var newUrl = window.location.pathname.replace('session-expired.html', '');
                    history.replaceState({}, null, newUrl);
                }

                if (ItxUtilsFct.isRtlLanguage()) {
                    setTimeout(function () {
                        $('body').removeClass('login-rtl');
                    }, 1500);
                }
            }
        };

        _this.checkOrderStatus = function () {
            const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);
            if (isCookieGroupAllowed) {
                const cookieName = 'registered_user_cookie';
                const cookie = inditex.readCookie(cookieName);
                const cookieTimeDays = CmsConfigSvc.getProperty('registered_user_cookie_days');
                if (cookie != null) {
                    let cookieData = JSON.parse(cookie);
                    if (inditex.iUserJSON.email) {
                        joyr.rest.xRestGetOrder(cookieData.orderId).then((orderData) => {
                            if (orderData.status !== cookieData.status) {
                                let newCookieData = {
                                    orderId: cookieData.orderId,
                                    date: cookieData.date,
                                    status: orderData.status
                                };
                                newCookieData = JSON.stringify(newCookieData);
                                inditex.writeCookie(cookieName, newCookieData, cookieTimeDays || 7);
                                localStorage.removeItem('buy');
                            }
                        });
                    }
                }
            }
        };
    }
})();
